<template>
  <!-- 重返月球 -->
  <div
    class="BackToMoon pointer align-center justify-center"
    @mouseenter="launchButtonEnter"
    @mouseleave="launchButtonLeave"
    @click="launchButtonClick"
    v-if="launchButtonShow"
  >
    <div :class="launchButtonHover ? 'hover' : ''">Top</div>
  </div>
</template>

<script>
export default {
  name: 'BackToMoon',
  components: {},
  data() {
    return {
      launchButtonShow: false,
      launchButtonHover: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    launchButtonClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 鼠标移入
    launchButtonEnter() {
      this.launchButtonHover = true
    },
    // 鼠标移出
    launchButtonLeave() {
      this.launchButtonHover = false
    },
    handleScroll() {
      const y = document.documentElement.scrollTop || document.body.scrollTop
      this.launchButtonShow = y >= 700
    }
  }
}
</script>
<style lang="scss">
.BackToMoon {
  width: 56px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(111, 124, 150, 0.25);
  border-radius: 12px;
  position: fixed;
  right: 32px;
  top: 85vh;
  z-index: 200;
  font-size: 12px;
  color: #666666;
  padding: 0 14px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  .hover {
    color: #c73128;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/BackToMoon.vue